import { Box, Card, CardActions, CardContent, Chip, ListItemButton, Stack, Typography } from "@mui/material";
import { memo, useState } from "react";
import styles from './ProfileItem.module.css';
import { IconButton } from "components/buttons";
import { ConfirmationDialog } from "components/dialogs";
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { AccessTime, ShoppingBag, ShoppingBagOutlined, TextSnippetOutlined } from "@mui/icons-material";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ProfileItem = memo(({isSelected, onDelete, onSelect, id, name, disabled, connected, trial, licenceRequired}) => {
  
  const [open, setOpen] = useState(false);

  const okHandler = (e) => {
    onDelete({id});
    setOpen(false);
  };

  const cancelHandler = (e) => {
    setOpen(false);
  };

  const makeItem = () => ({id, disabled, trial, name, licenceRequired});
  const getTrialText = () => trial ? `Триальный период, дней: ${trial.toString()}` : 'Без триального периода';
  const getLicenceText = () => licenceRequired ? 'Требуется лицензия' : 'Без лицензии';

  return (
    <ListItemButton
      sx={{
        pr:1, pb: 1, pl:0, pt: 0, flexGrow: 1,               
        '& :hover.MuiPaper-root':{
            backgroundColor: 'rgb(248, 248, 238) !important'
        },
        '&.Mui-selected .MuiCard-root': {
            backgroundImage: 'unset',
            backgroundColor: 'aliceblue'
        }
      }}
      className={"pagelist-item " + (disabled ? 'disabled' : '')}
      selected={isSelected}
    >
      <Card sx={{width:'100%'}} 
        onClick={() => onSelect(makeItem())}
      >
        <CardContent sx={{px:2, display: 'flex', alignItems: 'stretch', padding: '0 0 0 8px !important'}}>
          <Stack className={styles.nameWrapper} direction='row' sx={{alignItems: 'center'}}>
            <ShoppingBag color='secondary' sx={{mr: 1, fontSize: 28}}/>
            <Box m={1} sx={{width: '100%', overflow: 'hidden', textOverflow: 'ellipsis'}}>
              <Typography className={styles.name} sx={{mr: 1}}>{name}</Typography>
              <Chip icon={<FontAwesomeIcon icon={faLink} />} label={'Всего касс с профилем: ' + (connected ?? 0)} />  
            </Box>
          </Stack>
          <Stack className={styles.infoWrapper} direction="row" alignItems="center" justifyContent="space-between">
            <Box sx={{display: 'flex', flexDirection: 'column', mr: 1}}>
              <Stack direction='row' sx={{alignItems: 'center'}}>
                <AccessTime fontSize='small' color='action' sx={{mr: 1}}/>
                <div>{getTrialText()}</div>
              </Stack>
              <Stack direction='row' sx={{alignItems: 'center'}}>
                <TextSnippetOutlined fontSize='small' color='action' sx={{mr: 1}}/>
                <div>{getLicenceText()}</div>
              </Stack>
            </Box>
            <IconButton
              handler={(e) => {
                e.stopPropagation();
                if(!isSelected) onSelect(makeItem());
                setOpen(true);
              }}
              sx={{marginRight: '8px'}}
              text='Удалить профиль'  
              iconCmp={<DeleteOutlinedIcon className='delete-button'/>}
            />
          </Stack>  
          <ConfirmationDialog 
            title='Удалить профиль'
            text={<span>Удалить профиль <b>{name}</b>?</span>}
            open={open}
            onOk={okHandler}
            onCancel={cancelHandler}
          />
        </CardContent>
      </Card>
    </ListItemButton>
      
  );
});

export default ProfileItem;